<template>
  <div class="channel-info-form">
    <el-form :model="channelForm" ref="channelFormRef" :rules="rules" label-width="150px">
      <div class="form-row">
        <el-form-item label="渠道身份">
          <!-- <span style="color: #999">{{ flag === 1 ? '渠道商' : '合伙人' }}</span> -->
          <el-select v-model="channelForm.type" placeholder="请选择渠道身份">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="渠道名称" prop="name">
          <el-input v-model="channelForm.name" placeholder="请输入渠道名称" :maxlength="30" />
          <!-- <div class="validation-tip" v-if="!channelForm.name">超过最大长度30</div> -->
        </el-form-item>

        <el-form-item label="地址" prop="address">
          <el-input v-model="channelForm.address" placeholder="请输入地址" :maxlength="100" />
          <!-- <div class="validation-tip" v-if="channelForm.address && channelForm.address.length > 100">超过最大长度100</div> -->
        </el-form-item>
      </div>

      <div class="form-row">
        <el-form-item label="负责人" prop="admin">
          <el-input v-model="channelForm.admin" placeholder="请输入负责人" />
          <!-- <div class="validation-tip" v-if="channelForm.admin && channelForm.admin.length > 30">超过最大长度30</div> -->
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="channelForm.email" placeholder="请输入邮箱" :maxlength="30" />
          <!-- <div class="validation-tip" v-if="channelForm.email && channelForm.email.length > 30">超过最大长度30</div> -->
        </el-form-item>
      </div>

      <div class="form-row phone">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="channelForm.phone" placeholder="请输入手机号" />
          <span class="tip" style="color: red">渠道商登录使用，请谨慎填写</span>
          <!-- <div class="validation-tip">请输入正确的手机号码及区域前缀</div> -->
        </el-form-item>
      </div>
      <div class="form-row phone" v-if="channelForm.type === 1">
        <el-form-item label="新用户注册下单时效" prop="validityHours">
          <el-input type="number" v-model="channelForm.validityHours" placeholder="请输入数字" />
          <div class="tip" style="width: 330px">
            小时
            <label style="color: red; margin-left: 10px">
              用户扫描渠道码注册成功后的订单返佣时效
            </label>
          </div>
        </el-form-item>
      </div>
      <div class="form-row">
        <el-form-item label="渠道码有效期" prop="dateRange">
          <el-date-picker
            v-model="channelForm.dateRange"
            type="datetimerange"
            :start-placeholder="'开始日期'"
            :end-placeholder="'结束日期'"
            :value-format="'yyyy-MM-dd HH:mm:ss'"
          />
        </el-form-item>
      </div>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="channelForm.remark" placeholder="请输入备注" />
      </el-form-item>

      <div class="form-title">渠道比例</div>

      <div class="form-row">
        <el-form-item label="首笔订单" prop="fristOrder">
          <div class="ratio-input">
            <el-input
              v-model="channelForm.fristOrder"
              type="number"
              placeholder="请输入数字"
              style="width: 120px"
            />
            <span>%</span>
            <!-- <div class="validation-tip">请输入正确数值00:00-00:00</div> -->
          </div>
        </el-form-item>

        <el-form-item label="复购订单" prop="commondOrder">
          <div class="ratio-input">
            <el-input
              v-model="channelForm.commondOrder"
              type="number"
              placeholder="请输入数字"
              style="width: 120px"
            />
            <span>%</span>
            <!-- <div class="validation-tip">请输入正确数值00:00-00:00</div> -->
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'ChannelInfo',
    inject: ['flag'],
    props: {
      value: {
        type: Object,
        default: () => ({})
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    mounted() {},
    data() {
      // 新用户注册下单时效校验规则
      const validateHour = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入新用户注册下单时效'))
        }
        const reg = /^[1-9]\d*$/
        if (!reg.test(value)) {
          callback(new Error('请输入大于0的正整数'))
        } else {
          callback()
        }
      }
      // 手机号校验规则
      const validatePhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入手机号'))
        }
        // 简单的手机号验证规则
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }

      // 比例校验规则
      const validateRatio = (rule, value, callback) => {
        console.log(value)
        if (!value && value !== 0) {
          return callback(new Error('请输入比例值'))
        }
        const ratioReg = /^\d+(\.\d+)?$/
        if (!ratioReg.test(value)) {
          callback(new Error('请输入正确的比例值'))
        } else if (parseFloat(value) < 0 || parseFloat(value) > 100) {
          callback(new Error('比例值应在0-100之间'))
        } else {
          callback()
        }
      }

      // 名称校验
      const validateName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入渠道名称'))
        }
        if (value.length > 30) {
          return callback(new Error('长度不能超过30个字符'))
        }
        callback()
      }

      return {
        rules: {
          name: [
            { required: true, validator: validateName, trigger: 'blur' }
            // { max: 30, message: '长度不能超过30个字符', trigger: 'blur' }
          ],
          address: [{ max: 100, message: '长度不能超过100个字符', trigger: 'blur' }],
          admin: [{ max: 30, message: '长度不能超过30个字符', trigger: 'blur' }],
          email: [
            { max: 30, message: '长度不能超过30个字符', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
          ],
          phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
          validityHours: [{ required: true, validator: validateHour, trigger: 'blur' }],
          dateRange: [{ required: true, message: '请选择渠道码有效期', trigger: 'blur' }],
          fristOrder: [{ required: true, validator: validateRatio, trigger: 'blur' }],
          commondOrder: [{ required: true, validator: validateRatio, trigger: 'blur' }],
          remark: [{ max: 200, message: '长度不能超过30个字符', trigger: 'blur' }]
        },
        options: [
          {
            value: 1,
            label: '渠道商'
          },
          {
            value: 2,
            label: '合伙人'
          }
        ]
      }
    },
    computed: {
      channelForm: {
        get() {
          return this.value
        },
        set(newVal) {
          this.$emit('change', newVal)
        }
      }
    },
    methods: {
      // 表单验证
      validate() {
        return new Promise((resolve) => {
          this.$refs.channelFormRef.validate((valid) => {
            this.channelForm.startTime = this.channelForm.dateRange[0]
            this.channelForm.endTime = this.channelForm.dateRange[1]
            // this.channelForm.type = this.flag
            resolve(valid)
          })
        })
      },
      // 重置表单
      resetForm() {
        this.$refs.channelFormRef.resetFields()
      },
      // 判断表单是否有数据
      hasData() {
        return Object.values(this.channelForm).some((val) => val !== '')
      }
    }
  }
</script>

<style scoped lang="scss">
  .channel-info-form {
    padding: 20px 0;

    .form-row {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;

      .el-form-item {
        flex: 0 0 calc(50% - 20px);
        margin: 0 10px 22px;
      }

      &.phone {
        .tip {
          position: absolute;
          right: 0;
          transform: translateX(calc(100% + 5px));
          font-weight: bold;
          top: 0;
        }
      }
    }

    .form-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin: 10px 0 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeef5;
    }

    .ratio-input {
      display: flex;
      align-items: center;
      gap: 5px;

      span {
        white-space: nowrap;
      }
    }

    .validation-tip {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      margin-top: 4px;
    }
  }
</style>
